import { Injectable } from '@angular/core';
import { GlobalSettings } from '@core/models/common/global-settings';
import {
    getCurrencyOptions,
    getDatetimeOptions,
    getFormattedTimezones,
    getGlobalSettings,
    getIndustryList,
    getLocales,
    getPlatforms,
    getPositionColors,
    getTimezones
} from '@core/state/global/global-selectors';
import { IGlobalState } from '@core/state/global/global-state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable()
export class GlobalService {

    constructor(private store$: Store<IGlobalState>) {
    }

    getPositionColors(): Observable<string[]> {
        return this.store$.select(getPositionColors);
    }

    getPlatforms(): Observable<any> {
        return this.store$.select(getPlatforms);
    }

    getLocales(): Observable<{label: string, value: string}[]> {
        return this.store$.select(getLocales);
    }

    getTimezones(): Observable<any[]> {
        return this.store$.select(getTimezones);
    }

    getCurrencyOptions(): Observable<any> {
        return this.store$.select(getCurrencyOptions);
    }

    /**
     * To be used with dropdowns
     *
     * @returns {Observable<{id: string; value: string}[]>}
     */
    getFormattedTimezones(): Observable<{ id: string, value: string }[]> {
        return this.store$.select(getFormattedTimezones);
    }

    getSettings(): Observable<GlobalSettings> {
        return this.store$.select(getGlobalSettings);
    }

    getIndustries(): Observable<any> {
        return this.store$.select(getIndustryList);
    }

    getDatetimeOptions(): Observable<any> {
        return this.store$.select(getDatetimeOptions);
    }
}
